import Paragraphs from './Paragraphs'

export type { Paragraph } from './types'

export default Paragraphs
